<script setup>
import CustomTransition from '@/_company/components/CustomTransition.vue';
import { useCloseOnEscape } from '@/_company/composables/useCloseOnEscape';

const props = defineProps({
  size: {
    default: 'small',
    Type: String,
  },
});

const emit = defineEmits(['onClose']);

useCloseOnEscape(() => emit('onClose'));
</script>

<template>
  <div class="modal-wrapper">
    <div class="overflow" @click="() => emit('onClose')" />
    <CustomTransition class="modal-content" :class="size">
      <div class="modal-header">
        <slot name="header"></slot>
      </div>

      <div class="modal-body">
        <slot name="body"></slot>
      </div>

      <div class="modal-footer">
        <slot name="footer"></slot>
      </div>
    </CustomTransition>
  </div>
</template>

<style lang="scss" scoped>
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: middle;
  z-index: 999;
}

.overflow {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.modal-content {
  position: relative;
  overflow: auto;
  margin: auto;
  max-height: calc(100% - 96px);
  width: 100%;
  max-width: 480px;
  padding: $space-24;
  border-radius: 10px;
  background-color: #fff;
  text-align: center;

  &.large {
    text-align: left;
    width: 980px;
    max-width: 90%;
    padding: 0;

    @include max-width-tablet-large {
      max-height: none;
      height: 100%;
      max-width: 100%;
      border-radius: 0;
    }

    .modal-header {
      margin: 0;
    }
  }

  &.medium {
    max-width: 600px;

    @include max-width-tablet-large {
      max-height: 95%;
      width: 90%;
      padding: $space-16 $space-24;
    }
  }

  &.small {
    @include max-width-tablet-large {
      width: 90%;
    }
  }
}

.modal-header {
  margin: $space-12 0 0;
  flex: 1;

  &:empty {
    margin: 0;
  }
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: $space-16;
  padding-top: $space-16;

  @include tablet-large {
    flex-wrap: nowrap;
  }
}
</style>
